import React from 'react';
import { ToggleLeft, ToggleRight } from 'lucide-react';

export const FlagsTab = ({ featureFlags, onToggle }) => (
  <div data-testid="flags-tab">
    <h3 style={{ fontSize: '1.125rem', marginBottom: '1rem' }}>Feature Flags</h3>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      {featureFlags.map(flag => (
        <div key={flag.flag_name} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} data-testid={`flag-${flag.flag_name}`}>
          <div>
            <code style={{ fontWeight: 600, fontSize: '0.9375rem' }}>{flag.flag_name}</code>
            <p style={{ fontSize: '0.8125rem', color: 'var(--text-muted)', margin: '0.25rem 0 0' }}>{flag.description}</p>
          </div>
          <button
            onClick={() => onToggle(flag.flag_name, flag.enabled)}
            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            data-testid={`toggle-${flag.flag_name}`}
          >
            {flag.enabled
              ? <ToggleRight size={36} color="#10B981" />
              : <ToggleLeft size={36} color="var(--text-muted)" />
            }
          </button>
        </div>
      ))}
      {featureFlags.length === 0 && <p style={{ color: 'var(--text-muted)', textAlign: 'center' }}>No feature flags. Seed the database first.</p>}
    </div>
  </div>
);
